import React from 'react';
import PropTypes from 'prop-types';
import { t, Trans } from '@lingui/macro';
import { P, RadioGroup } from '@decisiv/ui-components';

export default function CircuitBreakerFilter({ handleForm, currentValue }) {
  return (
    <>
      <P marginBottom={1}>
        <Trans>Circuit Breaker</Trans>
      </P>
      <RadioGroup
        marginBottom={1}
        name="radio_circuit_breaker"
        items={[
          { label: t`Both`, value: 'Both' },
          {
            label: t`Enabled`,
            value: 'Circuit Breaker Enabled',
          },
          {
            label: t`Disabled`,
            value: 'Circuit Breaker Disabled',
          },
        ]}
        vertical
        value={currentValue}
        onChange={(e) => {
          handleForm({ event: e, field: 'circuitBreaker' });
        }}
      />
    </>
  );
}

CircuitBreakerFilter.propTypes = {
  handleForm: PropTypes.func.isRequired,
  currentValue: PropTypes.string.isRequired,
};
